export const item = {
  assigner: {
    name: 'Grobotic Bot',
    user_uuid: 'U074L1BHWGM',
    role: 'System',
  },
  task_uuid: '0cjvbv',
  status: 'Not Started',
  timeCreated: '2025-06-04T03:54:01.138Z',
  masterStatus: 'Done',
  dateDue: '2025-06-06T04:00:00.000Z',
  name: 'Budget Audits',
  queue: {
    firstName: 'Colin',
    lastName: 'Cavanaugh',
    user_uuid: 'U062JDP8R5X',
    role: 'DEV',
    name: 'Colin Cavanaugh',
    id: 'U062JDP8R5X',
    image_512: 'https://avatars.slack-edge.com/2024-04-26/7034672885236_ce1cdedb1a87cfc73125_512.jpg',
  },
  assignees: [
    {
      firstName: 'Colin',
      lastName: 'Cavanaugh',
      user_uuid: 'U062JDP8R5X',
      role: 'DEV',
      name: 'Colin Cavanaugh',
      id: 'U062JDP8R5X',
      image_512: 'https://avatars.slack-edge.com/2024-04-26/7034672885236_ce1cdedb1a87cfc73125_512.jpg',
    },
    {
      firstName: 'Patric',
      lastName: 'Cavanaugh',
      user_uuid: 'U015KLM51B6',
      role: 'MGMT',
      name: 'Patric Cavanaugh',
      id: 'U015KLM51B6',
      image_512: 'https://avatars.slack-edge.com/2023-06-28/5483598646407_05716fab16c88d8cbd0a_512.jpg',
    },
  ],
  isDmsMonthlyTask: true,
  taskDays: 5,
  orgId: 'c7982d02-753c-4deb-94fc-8726729402eb',
  startDate: '2025-06-01T04:00:00.000Z',
  isMonthlyTask: true,
  SK: 'MONTHLY_TASK_mbhexzjm_0cjvbv',
  PK: 'ORG_c7982d02-753c-4deb-94fc-8726729402eb',
  id: 'ORG_c7982d02-753c-4deb-94fc-8726729402eb',
  isMarketing: true,
  team_details: [
    {
      firstName: 'Colin',
      lastName: 'Cavanaugh',
      user_uuid: 'U062JDP8R5X',
      role: 'DEV',
      name: 'Colin Cavanaugh',
      id: 'U062JDP8R5X',
      image_512: 'https://avatars.slack-edge.com/2024-04-26/7034672885236_ce1cdedb1a87cfc73125_512.jpg',
    },
    {
      firstName: 'Patric',
      lastName: 'Cavanaugh',
      user_uuid: 'U015KLM51B6',
      role: 'MGMT',
      name: 'Patric Cavanaugh',
      id: 'U015KLM51B6',
      image_512: 'https://avatars.slack-edge.com/2023-06-28/5483598646407_05716fab16c88d8cbd0a_512.jpg',
    },
  ],
  type: 'monthly',
}
